export default __webpack_public_path__ + "static/media/deAppImages.31beb942.png";